import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { accountsService } from 'src/services/accounts.service'
import { QUERY_KEYS } from 'src/constants'
import { IFilter } from 'src/components/filter/types/filter.types'
import { removeDefaultParams } from 'src/common/utils'

const initialAccountScannersFilterValues = {
  query: '',
}

export const useAccountScanners = (filter?: IFilter) => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.ACCOUNT_SCANNERS, accountId, filter],
    async () =>
      accountId
        ? accountsService.getAccountScanners(
          accountId,
          removeDefaultParams(filter, initialAccountScannersFilterValues),
        )
        : null,
    {
      keepPreviousData: true,
    },
  )
}
